const isNumeric = /^[0-9]+$/;

export default isNumeric;
